import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full min-h-[70vh] flex flex-col items-center justify-center px-6 py-12" data-id="element-101">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center" data-id="element-102">
        <h1 className="font-playfair text-4xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight" data-id="element-103">
          Tu cerebro no está roto. Está atrapado en modo alarma.{' '}
          <span className="text-amber-gold" data-id="element-104">Aquí está el interruptor.</span>
        </h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="text-xl md:text-2xl text-warm-cream/80 font-light" data-id="element-105">
          El Kit de Rescate de 15 Minutos para Apagar la Ansiedad y Dormir Mejor
        </motion.p>

        <motion.img src="https://cdn.magicpatterns.com/uploads/qThLRYxDvrmmpUiuCbHsaz/Imagen_Hero.png" alt="NEURO RESET Somático — Kit digital en tablet y móvil" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="max-w-2xl w-full mx-auto mt-12 rounded-xl" data-id="element-106" />

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} className="mt-10 text-center" data-id="element-107">
          <motion.a href="#precio" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-3 bg-amber-gold text-dark-navy font-bold text-lg md:text-xl px-12 py-6 rounded-full shadow-2xl hover:shadow-amber-gold/20 transition-all" data-id="element-108">
            Quiero mi Neuro Reset Somático
            <ArrowRight className="w-6 h-6" strokeWidth={2.5} data-id="element-109" />
          </motion.a>
          <p className="text-warm-cream/60 mt-4 text-sm md:text-base" data-id="element-110">
            Acceso inmediato. Sin esperas. Empieza esta noche.
          </p>
          <p className="text-warm-cream/40 mt-1 text-xs md:text-sm" data-id="element-111">
            Garantía de satisfacción de 7 días.
          </p>
          <p className="text-warm-cream/40 mt-1 text-xs md:text-sm max-w-md mx-auto" data-id="element-112">
            Practica el kit durante 7 días. Si no notas ninguna diferencia en tu
            sueño o ansiedad, te devuelvo el 100% de tu dinero. Sin preguntas.
          </p>
        </motion.div>
      </motion.div>
    </section>;
}